import { inject } from '@angular/core'
import { ActivatedRouteSnapshot } from '@angular/router'
import { tap } from 'rxjs/operators'
import { JmeleonActionsPermissionService } from '../services/jmeleon-actions-permission.service'

export const jmlPermissionGuard = (next: ActivatedRouteSnapshot) => {
  const jmlActionPermissionService = inject(JmeleonActionsPermissionService)
  const permissions = next.data.permissions as Array<string>
  const permissionVars = next.data.permissionVars
  return jmlActionPermissionService
    .userHasPermissionForAllActions(permissions, permissionVars)
    .pipe(tap((result) => console.log(`user can navigate to ${next.url.join()}: ${result}`)))
}
